<div class="col">
  <div class="row">
    @if (this.isTunnel) {
    }
  </div>
  <div class="row h-100" style="margin: 0">
    <div id="rendering" class="preview" [style.background-image]="
        getEmplacementPictureUrl() !== undefined && step === 1
          ? 'url(' + baseImgURL + getEmplacementPictureUrl() + ')'
          : ''
      " *ngIf="customer.context !== CONFIG_CONTEXT.CARPENTRY">
      <ng-closet-doors-standard-preview *ngIf="customer.context === CONFIG_CONTEXT.CLOSET_DOORS_STANDARD"
        [finishesStep]="subStep" [step]="step" [finishesRendered]="finishesRendered"></ng-closet-doors-standard-preview>

      <ng-fence-preview #preview *ngIf="customer.context === CONFIG_CONTEXT.FENCE" [step]="step"></ng-fence-preview>

      <ng-decking-boards-preview #preview *ngIf="customer.context === CONFIG_CONTEXT.DECKING_BOARDS" [subStep]="subStep"
        [step]="step"></ng-decking-boards-preview>

      <ng-closet-doors-custom-preview #preview *ngIf="customer.context === CONFIG_CONTEXT.CLOSET_DOORS_CUSTOM"
        [step]="step"></ng-closet-doors-custom-preview>

      <ng-workbench-preview-three #preview *ngIf="customer.context === CONFIG_CONTEXT.WORKBENCH" [subStep]="subStep"
        [step]="step" [isSummary]="step === finalStep"></ng-workbench-preview-three>
    </div>
    <div id="renderDiv" style="display: none" class="preview" [style.background-image]="
        getEmplacementPictureUrl() !== null && step === 1 ? 'url(' + baseImgURL + getEmplacementPictureUrl() + ')' : ''
      ">
      <ng-closet-doors-standard-preview *ngIf="customer.context === CONFIG_CONTEXT.CLOSET_DOORS_STANDARD"
        [finishesStep]="subStep" [step]="step"
        [finishesRendered]="this.finishesRendered"></ng-closet-doors-standard-preview>

      <ng-decking-boards-preview *ngIf="customer.context === CONFIG_CONTEXT.DECKING_BOARDS" [subStep]="subStep"
        [step]="step"></ng-decking-boards-preview>
    </div>

    <div class="configurator">
      @if (!this.isTunnel && (this.internalConfig || this.step != 1)) {
      <div class="configurator__header">
        <!-- Nouveau projet -->
        <ng-casto-btn class="blue" (click)="newProject()"
          [label]="'2d-configurator.header.newproject' | translate"></ng-casto-btn>

        <!-- Mes projets -->
        <ng-casto-btn class="blue" [disabled]="isMyProjectsButtonDisabled()" (click)="myProjects()"
          [label]="'2d-configurator.header.myprojects' | translate"></ng-casto-btn>

        <!-- Dupliquer -->
        <ng-casto-btn class="blue" [disabled]="isDuplicateProjectButtonDisabled()" (click)="duplicateProject()"
          [label]="'2d-configurator.header.duplicate' | translate"></ng-casto-btn>

        <!-- Enregistrer -->
        <ng-casto-btn class="blue" [disabled]="isSaveProjectButtonDisabled()" (click)="saveProject()"
          [label]="'2d-configurator.header.save' | translate" [loading]="isSaveLoading"></ng-casto-btn>
      </div>
      }

      <!-- Alert contenant diverses messages indiquant à l'utilisateur si ses actions ont réussi -->
      <alert></alert>

      <div class="configurator__wrapper">
        @if (!this.isTunnel) {
        <h2 class="title" *ngIf="internalConfig || step != 1">
          <div class="custom-form-row" *ngIf="isTitleEditing">
            <input type="text" class="edit-title" (change)="changeTitle($event)" [value]="getCurrentTitle()" />
            <ng-casto-btn class="blue save" [label]="'2d-configurator.save' | translate"
              (click)="isTitleEditing = false"></ng-casto-btn>
          </div>
          <span class="title-text" *ngIf="!isTitleEditing">
            {{
            customer.context == CONFIG_CONTEXT.CLOSET_DOORS_STANDARD
            ? current.closetDoors.title
            : appService.configuration.title
            }}
            <svg class="icon-action-edit" (click)="isTitleEditing = !isTitleEditing">
              <use xlink:href="assets/img/icons.svg#icon-action-edit"></use>
            </svg>
          </span>
        </h2>
        }

        <!-- Configurateurs -->
        <div class="configurator__container shadow" [ngClass]="{ blue: step > finalStep }">
          <div class="stepper-wrapper" *ngIf="step <= finalStep && internalConfig">
            <div class="stepper-item" *ngFor="let stepper of getStepperItems()" [ngClass]="{
                active: step === stepper.index,
                completed: step > stepper.index,
              }" (click)="navigatePage(stepper.index)">
              <div class="step-counter"></div>
              <div class="step-name">{{ stepper.title | translate }}</div>
            </div>
          </div>

          <ng-closet-doors-standard-configuration *ngIf="customer.context === CONFIG_CONTEXT.CLOSET_DOORS_STANDARD"
            [step]="step" (setGlobalLoading)="setGlobalLoading($event)" (getFinishesStep)="getSubstep($event)"
            (finishesRendered)="onFinishesRendered()">
          </ng-closet-doors-standard-configuration>

          <ng-closet-doors-custom-configuration *ngIf="customer.context === CONFIG_CONTEXT.CLOSET_DOORS_CUSTOM"
            [step]="step" (setGlobalLoading)="setGlobalLoading($event)">
          </ng-closet-doors-custom-configuration>

          <ng-fence-configuration *ngIf="customer.context === CONFIG_CONTEXT.FENCE" [step]="step"
            (setGlobalLoading)="setGlobalLoading($event)" (getFinishesStep)="getSubstep($event)">
          </ng-fence-configuration>

          <ng-decking-boards-configuration *ngIf="customer.context === CONFIG_CONTEXT.DECKING_BOARDS" [step]="step"
            (setGlobalLoading)="setGlobalLoading($event)" (getFinishesStep)="getSubstep($event)">
          </ng-decking-boards-configuration>

          <ng-workbench-configuration *ngIf="customer.context === CONFIG_CONTEXT.WORKBENCH" [step]="step"
            (setGlobalLoading)="setGlobalLoading($event)" (getFinishesStep)="getSubstep($event)"
            (updateStepperItems)="updateStepperItems($event)" (changePage)="navigatePage($event)"
            (splashbackChanged)="onSplashbackChanged($event)" (disableNextButton)="onDisableNextFromSplashback($event)">
          </ng-workbench-configuration>

          <ng-carpentry-configuration *ngIf="customer.context === CONFIG_CONTEXT.CARPENTRY" [step]="getCurrentStep()"
            (setGlobalLoading)="setGlobalLoading($event)" (changePage)="navigatePage($event)">
          </ng-carpentry-configuration>

          <div class="footer">
            <ng-casto-btn class="blue next" [label]="'2d-configurator.buttons.next' | translate" (click)="changePage()"
              [loading]="isNextButtonLoading" [disabled]="!isNextButtonActive() || isSplashbackForceDisabled"
              *ngIf="!isNextButtonHidden() && customer.context !== CONFIG_CONTEXT.CARPENTRY"></ng-casto-btn>
            <ng-casto-btn class="blue next smaller" [label]="'2d-configurator.buttons.carpentry-next' | translate"
              (click)="navigatePage(finalStep)" [loading]="isNextButtonLoading" [disabled]="!isNextButtonActive()"
              *ngIf="!isNextButtonHidden() && customer.context === CONFIG_CONTEXT.CARPENTRY"></ng-casto-btn>
            @if (step === finalStep) {
            <div class="final-button">
              @if (this.isTunnel) {
              <ng-casto-btn class="blue next" [label]="'2d-configurator.buttons.next' | translate"
                (click)="nextTunnelStep()" *ngIf="customer.context !== CONFIG_CONTEXT.CARPENTRY">
              </ng-casto-btn>
              } @else {
              <!-- Loader -->
              <ng-casto-loader *ngIf="isQuoteAndOrderLoading"></ng-casto-loader>
              <!-- Discount -->
              <a *ngIf="
                      customer.context === CONFIG_CONTEXT.CLOSET_DOORS_CUSTOM &&
                      !isQuoteAndOrderLoading &&
                      isVendorApp &&
                      hasPrice
                    " class="discount-manual" [hidden]="hasNationalDiscount()" (click)="updateDiscount($event)">
                {{
                hasManualDiscount()
                ? ('2d-configurator.buttons.cancel-discount' | translate)
                : ('2d-configurator.buttons.discount' | translate)
                }}
                <a class="casto-tooltip" [tooltip]="'2d-configurator.buttons.discount-detail' | translate"
                  [positionTop]="true">?</a>
              </a>
              <!-- Generate Quote -->
              <a *ngIf="!isQuoteAndOrderLoading && hasPrice" class="quote text-dark" (click)="openQuotation()">{{
                '2d-configurator.buttons.generate-quote' | translate
                }}</a>
              <!-- Ajout au panier (client uniquement, si activé pour ce configurateur dans l'administration) -->
              @if (showAddToBasketButton) {
                @if (isAddingToBasket) {
                  <ng-casto-loader></ng-casto-loader>
                } @else if (projectAddedToBasket) {
                  <a class="add-to-basket text-dark disabled">{{
                    '2d-configurator.buttons.project-added-to-basket' | translate
                  }}</a>
                } @else {
                  <a class="add-to-basket text-dark" (click)="addToBasket()">{{
                    '2d-configurator.buttons.add-to-basket' | translate
                  }}</a>
                }
              }
              <!-- Send Order -->
              <button type="button" *ngIf="!isQuoteAndOrderLoading && !orderingInFlight && isVendorApp && hasPrice"
                class="order text-dark" [disabled]="isOrderButtonDisabled()" (click)="order(false)">{{
                '2d-configurator.buttons.order' | translate }}</button>

              <a *ngIf="!isQuoteAndOrderLoading && !orderingInFlight && isVendorApp && hasPrice" class="order text-dark"
                [ngClass]="{ disabled: isOrderButtonDisabled() }" [hidden]="isContextWorkbench()"
                (click)="order(true)">Prévisite</a>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="global-loading" *ngIf="isGlobalLoading">
    <ng-casto-loader></ng-casto-loader>
  </div>
  <div class="top-loading" *ngIf="isSaveLoading || isNextButtonLoading"></div>
</div>
